import { updateDatadogUser } from '@/monitoring/datadog.ts'
import { isAuthenticated } from '@/resources/services/permission/auth'
import { SELLER_DATA } from '@/resources/utils'
import { datadogLogs } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum'
import { LogLevel } from './enum'
import { Logger, LogProps, LogPropValue } from './types'

const sanitize = (value?: LogPropValue) => value || 'no_data'

const getLogEnvironment = (): string => {
  const buildEnv = process.env.ENV
  if (typeof buildEnv === 'string' && buildEnv !== '') {
    return buildEnv
  }
  return 'unknown'
}

const log = (logLevel: LogLevel, message: string, props: LogProps) => {
  const properties: LogProps = {
    ...props,
    log_environment: getLogEnvironment(),
  }

  updateDatadogUser()
  datadogLogs.logger[logLevel](message, properties)
  datadogRum.addAction(message, { level: logLevel, ...properties })
}

export const logger: Logger = {
  info: (message, props = {}) => log(LogLevel.INFO, message, props),
  warn: (message, props = {}) => log(LogLevel.WARN, message, props),
  error: (message, props = {}) => log(LogLevel.ERROR, message, props),
}

export const getSellerPropsForLogs = () => {
  const sellerData = JSON.parse(localStorage.getItem(SELLER_DATA) ?? '{}')
  const pocInfo = sellerData?.seller

  return {
    poc_id: sanitize(pocInfo?.id),
    status: sanitize(pocInfo?.status),
    province: sanitize(pocInfo?.address?.provinceCode),
    city: sanitize(pocInfo?.address?.city),
    category: sanitize(pocInfo?.category),
    is_store_open: sanitize(pocInfo?.shop?.isOpen),
    delivery_methods: sanitize(pocInfo?.shop?.deliveryMethods),
    twin_seller_id: sanitize(pocInfo?.twinSellerId),
    user_role: sanitize(sellerData?.user?.role),
    is_authenticated: isAuthenticated(),
  }
}
